import { styled } from '@mui/material/styles';

export const StyledCGVContainer = styled('div')(() => ({
  width: '100%',
}));

export const StyledLoadingContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4em 2em',
  minHeight: 200,
}));

export const StyledErrorContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '3em 2em',
  textAlign: 'center',
  gap: '1em',
  color: '#646776',
}));

export const StyledTextContainer = styled('div')(() => ({
  marginBottom: '3em',
  marginTop: '2em',
  fontSize: '1rem',
}));

export const StyledArticleTitle = styled('p')(() => ({
  fontWeight: 'bold',
}));

export const StyledTitle = styled('h1')(() => ({
  fontFamily: 'PT Serif',
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: 34,
  textAlign: 'center',
}));

export const StyledTextPadding = styled('div')(() => ({
  paddingTop: '2em',
}));

export const StyledUlsStyle = styled('ul')(() => ({
  listStyleType: '"-   "',
}));

export const StyledTextCenter = styled('p')(() => ({
  textAlign: 'center',
}));
